// extracted by mini-css-extract-plugin
module.exports = {"gridWrapper":"favorites-list_gridWrapper__rVCEE","favoritesGrid":"favorites-list_favoritesGrid__68JT8"};